import { render } from "./ExplorePromotion.vue?vue&type=template&id=42f511e0"
import script from "./ExplorePromotion.vue?vue&type=script&lang=js"
export * from "./ExplorePromotion.vue?vue&type=script&lang=js"

import "./ExplorePromotion.vue?vue&type=style&index=0&id=42f511e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__